import { graphql } from 'gatsby';

export const TableDocumentFragment = graphql`
  fragment TableFlexibleCell on DatoCmsFlexibleTableCell {
    id
    whatToShow
    date
    likelihood
    difficulty
    module
    document {
      ...TableDocumentFields
    }
  }
`;

export const moduleTitle = (cell) => {
  const titles = {
    'as-core': 'AS Core',
    fs1: 'FS1',
    fs2: 'FS2',
    fm1: 'FM1',
    fm2: 'FM2',
    fp2: 'FP2',
    d1: 'D1',
    d2: 'D2',
  };

  return titles[cell] ?? cell;
};
